import Vue from 'vue'
Vue.mixin({
    methods: {
        pys_generate_token(length) {
            //edit the token allowed characters
            var a = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890".split("");
            var b = [];
            for (var i = 0; i < length; i++) {
                var j = (Math.random() * (a.length - 1)).toFixed(0);
                b[i] = a[j];
            }
            return b.join("");
        },
        trackFbLead(content_category, content_name){
            let eventId = this.pys_generate_token(36);
            let eventName = 'Lead';
            this.$analytics.fbq.event(eventName, {
                content_category: content_category,
                content_name: content_name
            }, eventId);

            var bodyFormData = new FormData();
            bodyFormData.append('data[page_title]', content_category + ' ' + content_name);
            bodyFormData.append('data[plugin]', 'PixelYourSite');
            bodyFormData.append('data[traffic_source]', 'sgrlucegas.com');
            bodyFormData.append('action', 'pys_api_event');
            bodyFormData.append('data[landing_page]', 'https://www.sgrlucegas.com/check-up-energetico/');
            bodyFormData.append('pixel', 'facebook');
            bodyFormData.append('event', eventName);
            bodyFormData.append('eventID', eventId);
            bodyFormData.append('ids[]', '315346508840494');
            bodyFormData.append('url', window.location.href);
            this.axios({
                method: "post",
                url: process.env.VUE_APP_WEB_PATH + 'wp-admin/admin-ajax.php',
                data: bodyFormData,
                headers: { "Content-Type": "text/html; charset=UTF-8" },
            });
        },

        trackFbViewContent(content_category, content_name){
            let eventId = this.pys_generate_token(36);
            let eventName = 'ViewContent';
            this.$analytics.fbq.event(eventName, {
                content_category: content_category,
                content_name: content_name
            }, eventId);

            var bodyFormData = new FormData();
            bodyFormData.append('data[page_title]', content_category + ' ' + content_name);
            bodyFormData.append('data[plugin]', 'PixelYourSite');
            bodyFormData.append('data[traffic_source]', 'sgrlucegas.com');
            bodyFormData.append('action', 'pys_api_event');
            bodyFormData.append('data[landing_page]', 'https://www.sgrlucegas.com/check-up-energetico/');
            bodyFormData.append('pixel', 'facebook');
            bodyFormData.append('event', eventName);
            bodyFormData.append('eventID', eventId);
            bodyFormData.append('ids[]', '315346508840494');
            bodyFormData.append('url', window.location.href);
            this.axios({
                method: "post",
                url: process.env.VUE_APP_WEB_PATH + 'wp-admin/admin-ajax.php',
                data: bodyFormData,
                headers: { "Content-Type": "text/html; charset=UTF-8" },
            });
        }
    }
});